import localForage from 'localforage';

const getJsonItem = key => localForage.getItem(key).then((item) => {
  try {
    return item ? JSON.parse(item) : null;
  } catch (error) {
    return null;
  }
});

export default {
  ...localForage,
  getJsonItem,
};
